import React, {FC} from 'react'
import Typography from '@material-ui/core/Typography'

import {TextProps} from 'components/Heading'

const Subtitle2: FC<TextProps> = ({variant = 'subtitle2', ...props}) => (
  <Typography variant={variant} {...props} />
)

export default Subtitle2
